import React from 'react';
import { Box, Typography } from '@mui/material';

import AccessTimeIcon from '@mui/icons-material/AccessTime';
import PauseCircleOutlineIcon from '@mui/icons-material/PauseCircleOutline';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';

export const iconMap = {
  AccessTimeIcon: <AccessTimeIcon style={{ paddingRight: '0.5rem' }} />,
  PauseCircleOutlineIcon: (
    <PauseCircleOutlineIcon style={{ paddingRight: '0.5rem' }} />
  ),
  ErrorOutlineIcon: <ErrorOutlineIcon style={{ paddingRight: '0.5rem' }} />,
};

const returnWaitIcon = waitIcon => iconMap[waitIcon] || null;

const ItineraryWaitCard = ({ info, id_option, flight, index }) => (
  <Box
    key={`wait-box-${id_option}-${flight.flight_number}-${index}`}
    id={`wait-box-${id_option}-${flight.flight_number}-${index}`}
    sx={{
      borderRadius: '15px',
      backgroundColor: '#ffd3d3',
      px: 1,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      mb: 2,
      height: 'auto',
    }}
  >
    {returnWaitIcon(info.waitIcon)}
    <Typography
      sx={{
        fontWeight: 600,
        color: '#000',
        marginTop: '8px',
        marginBottom: '8px',
        fontSize: '13px',
      }}
    >
      {info.data.message}
    </Typography>
  </Box>
);

export default ItineraryWaitCard;
